import {memo} from 'react';

import styled from 'styled-components';

import TenbisCreditIcon from '~/assets/images/icons/tenbisCredit.svg?react';
import TenbisIcon from '~/assets/images/icons/tenbisCard.svg?react';
import {getLocalizationService} from '~/shared/services/localisationService';
import {media} from '~/shared/theme/media';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';

import {Title} from '../MoneyCardDetails/components/shared.styles';

const TenbisCreditContainer = styled.div`
  margin: 0 16px;
  ${media.minMobile`
    margin: 0;
  `}
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
  ${media.minLargeTablet`
    margin-top: 36px;
  `}
`;

const CreditTitle = styled(Title)`
  padding: 0;
  margin: 0;
  font-size: 16px;
  ${media.minMobile`
    font-size: 18px;
  `}
`;

const Content = styled.div`
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 8px;
  background: ${({theme}) => theme.colors.surface};
  box-shadow: ${({theme}) => theme.shadows.elevationCard};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${media.minMobile`
    font-size: 26px;
    padding: 16px 24px;
    height: 92px;
  `}
`;

const Balance = styled.span`
  font-weight: 700;
  font-size: 16px;
  color: ${({theme}) => theme.colors.contentDefault};
  ${media.minMobile`
    font-weight: 300;
    font-size: 26px;
  `}
`;

const Label = styled.span`
  font-weight: 300;
  font-size: 12px;
  color: ${({theme}) => theme.colors.contentSubdued};
  ${media.minMobile`
    font-size: 13px;
  `}
`;

const Icon = styled(TenbisCreditIcon)`
  path {
    fill: ${({theme}) => theme.colors.actionBrand};
  }

  ${flipOnLTR`
    margin-left: 8px;
  `}
`;

const IconTenbis = styled(TenbisIcon)`
  ${flipOnLTR`
    margin-left: 8px;
  `}
`;

const PrepaidCard = memo(
  ({balance, cardSuffix, isTenbisCredit}: {balance: number; cardSuffix: string; isTenbisCredit: boolean}) => {
    const {t} = getLocalizationService();
    return (
      <TenbisCreditContainer>
        <Header>
          {isTenbisCredit ? <Icon /> : <IconTenbis />}
          <CreditTitle>{isTenbisCredit ? t('tenbis_credit') : t('card_number_xxxx', {cardSuffix})}</CreditTitle>
        </Header>
        <Content>
          <Balance>₪{balance.toFixed(2)}</Balance>
          <Label>{t('balance')}</Label>
        </Content>
      </TenbisCreditContainer>
    );
  },
);

export default PrepaidCard;
